import { buildIsServiceFn } from '../../utils';

import { SERVICE_TYPES_DESTINATION } from '../../constants';

const isDestinationService = buildIsServiceFn(SERVICE_TYPES_DESTINATION);

export default isDestinationService;
